import { Base } from '../base-component';
import './form-builder.component.scss';

export class FormBuilder extends Base {

	buttonConverter: any;
	containerModal: any;
	inputs: any;

	constructor(element: Element){

		super(element);

	}

	init(){

		this.buttonConverter = Array.from(this.element.querySelectorAll('.js-converter'));
		this.inputs = Array.from(this.element.querySelectorAll('input'));

	}

	bindEvents() {

		if(this.buttonConverter) {

			this.buttonConverter.map((item) => item.addEventListener('click', (event)=>{

				let element = undefined;
				if(event.currentTarget) {
					element = event.currentTarget;
				}else{
					element = event.target;
				}

				let getForm = element.closest('form');
				let formType = getForm.getAttribute('data-type');
				this.containerModal = this.element.querySelector('.form-container');
				let getOutput = this.element.querySelector('.form-builder__output');

				this.createForm(getOutput, formType);

			}));

		}

		if(this.inputs) {

			this.inputs.map((input) => input.addEventListener('keydown', (event)=>{

				let element = undefined;
				if(event.currentTarget) {
					element = event.currentTarget;
				}else{
					element = event.target;
				}

				let getForm = element.closest('form');
				let formType = getForm.getAttribute('data-type');
				this.containerModal = this.element.querySelector('.form-container');
				let getOutput = this.element.querySelector('.form-builder__output');

				this.createForm(getOutput, formType);

			}));

			this.inputs.map((input) => input.addEventListener('paste', (event)=>{

				let element = undefined;
				if(event.currentTarget) {
					element = event.currentTarget;
				}else{
					element = event.target;
				}

				let getForm = element.closest('form');
				let formType = getForm.getAttribute('data-type');
				this.containerModal = this.element.querySelector('.form-container');
				let getOutput = this.element.querySelector('.form-builder__output');

				setTimeout(()=>{

					this.createForm(getOutput, formType);

				}, 200);

			}));

		}

	}

	createForm(output, type) {

		let content = ``;

		// fields
		let getFieldDescription: any = this.element.querySelector('input[name=form-builder_field--description');

		let getFieldTitleLabel: any = this.element.querySelector('input[name=form-builder_field--title__label');
		let getFieldTitleOption1: any = this.element.querySelector('input[name=form-builder_field--title__value--1');
		let getFieldTitleOption2: any = this.element.querySelector('input[name=form-builder_field--title__value--2');
		let getFieldTitleOption3: any = this.element.querySelector('input[name=form-builder_field--title__value--3');
		let getFieldTitleOption4: any = this.element.querySelector('input[name=form-builder_field--title__value--4');
		let getFieldTitleOption5: any = this.element.querySelector('input[name=form-builder_field--title__value--5');

		let getFieldFirstnameLabel: any = this.element.querySelector('input[name=form-builder_field--firstname__label');
		let getFieldFirstnamePlaceholder: any = this.element.querySelector('input[name=form-builder_field--firstname__placeholder');
		let getFieldSurnameLabel: any = this.element.querySelector('input[name=form-builder_field--surname__label');
		let getFieldSurnamePlaceholder: any = this.element.querySelector('input[name=form-builder_field--surname__placeholder');
		let getFieldTelephoneLabel: any = this.element.querySelector('input[name=form-builder_field--telephone__label');
		let getFieldTelephonePlaceholder: any = this.element.querySelector('input[name=form-builder_field--telephone__placeholder');
		let getFieldEmailLabel: any = this.element.querySelector('input[name=form-builder_field--email__label');
		let getFieldEmailPlaceholder: any = this.element.querySelector('input[name=form-builder_field--email__placeholder');
		let getFieldQueryLabel: any = this.element.querySelector('input[name=form-builder_field--query__label');
		let getFieldQueryPlaceholder: any = this.element.querySelector('input[name=form-builder_field--query__placeholder');
		let getFieldLockValue: any = this.element.querySelector('input[name=form-builder_field--lock');
		let getFieldButtonValue: any = this.element.querySelector('input[name=form-builder_field--button');

		let valueDescription: any = 'Fill in your information and let us call you';
		let valueTitleLabel: any = 'Title';
		let valueTitleValue1: any = 'Mr';
		let valueTitleValue2: any = 'Mrs';
		let valueTitleValue3: any = 'Miss';
		let valueTitleValue4: any = 'Ms';
		let valueTitleValue5: any = 'Other';

		let valueFirstnameLabel: any = 'First Name';
		let valueFirstnamePlaceholder: any = 'Enter your first name';
		let valueSurnameLabel: any = 'Surname';
		let valueSurnamePlaceholder: any = 'Enter your surname';
		let valueTelephoneLabel: any = 'Telephone Number';
		let valueTelephonePlaceholder: any = 'Enter your telephone number';
		let valueEmailLabel: any = 'Email Address';
		let valueEmailPlaceholder: any = 'Enter your email address';
		let valueQueryLabel: any = 'Query / Comments';
		let valueQueryPlaceholder: any = 'Enter your query or comments';
		let valueLockValue: any = 'Your information will be managed securely.';
		let valueButtonValue: any = 'Call me back';
		
		if(getFieldDescription.value !== ''){
			valueDescription = getFieldDescription.value;
		}
		if(getFieldTitleLabel.value !==  '') {
			valueTitleLabel = getFieldTitleLabel.value;
		}
		if(getFieldTitleOption1.value !==  '') {
			valueTitleValue1 = getFieldTitleOption1.value;
		}
		if(getFieldTitleOption2.value !==  '') {
			valueTitleValue2 = getFieldTitleOption2.value;
		}
		if(getFieldTitleOption3.value !==  '') {
			valueTitleValue3 = getFieldTitleOption3.value;
		}
		if(getFieldTitleOption4.value !==  '') {
			valueTitleValue4 = getFieldTitleOption4.value;
		}
		if(getFieldTitleOption5.value !==  '') {
			valueTitleValue5 = getFieldTitleOption5.value;
		}
		if(getFieldFirstnameLabel.value !==  '') {
			valueFirstnameLabel = getFieldFirstnameLabel.value;
		}
		if(getFieldFirstnamePlaceholder.value !==  '') {
			valueFirstnamePlaceholder = getFieldFirstnamePlaceholder.value;
		}
		if(getFieldSurnameLabel.value !==  '') {
			valueSurnameLabel = getFieldSurnameLabel.value;
		}
		if(getFieldSurnamePlaceholder.value !==  '') {
			valueSurnamePlaceholder = getFieldSurnamePlaceholder.value;
		}
		if(getFieldTelephoneLabel.value !==  '') {
			valueTelephoneLabel = getFieldTelephoneLabel.value;
		}
		if(getFieldTelephonePlaceholder.value !==  '') {
			valueTelephonePlaceholder = getFieldTelephonePlaceholder.value;
		}
		if(getFieldEmailLabel.value !==  '') {
			valueEmailLabel = getFieldEmailLabel.value;
		}
		if(getFieldEmailPlaceholder.value !==  '') {
			valueEmailPlaceholder = getFieldEmailPlaceholder.value;
		}
		if(getFieldQueryLabel.value !==  '') {
			valueQueryLabel = getFieldQueryLabel.value;
		}
		if(getFieldQueryPlaceholder.value !==  '') {
			valueQueryPlaceholder = getFieldQueryPlaceholder.value;
		}
		if(getFieldLockValue.value !==  '') {
			valueLockValue = getFieldLockValue.value;
		}
		if(getFieldButtonValue.value !==  '') {
			valueButtonValue = getFieldButtonValue.value;
		}

		// content
		let getFormName: any = this.element.querySelector('input[name=form-builder__name]');
		let getFormRecipient: any = this.element.querySelector('input[name=form-builder__recipient]');
		let getFormEmail: any = this.element.querySelector('input[name=form-builder__email]');
		let getFormSubject: any = this.element.querySelector('input[name=form-builder__subject]');

		if(type === 'nigeria-account-enquiry') {

			let getFormProduct: any = this.element.querySelector('input[name=form-builder__product]');

			content = `<form class="form" id="apply-now-submit_application_mail"
				data-frmcontainer="`+getFormName.value+`">
				<input type="hidden" name="recipient"
					value="`+getFormRecipient.value+`">
				<input type="hidden" name="email"
					value="`+getFormEmail.value+`">
				<input type="hidden" name="subject" value="`+getFormSubject.value+`">
				<input type="hidden" name="redirect" value="">
				<input type="hidden" name="product" value="`+getFormProduct.value+`">
				<div class="form__loader--container">
					<img class="search__results-busy"
						src="/file_source/assets/img/spinner.gif" />
				</div>
				<div class="form__fields--container">
					<div class="form__group ">
						<p style="margin-bottom: 0px;">`+valueDescription+`</p>
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueTitleLabel+`
						</label>
						<div class="form__select">
							<select name="title" class="form__input  form__input--required 
js-title ">
								<option value="Mr">`+valueTitleValue1+`</option>
								<option value="Mrs">`+valueTitleValue2+`</option>
								<option value="Miss">`+valueTitleValue3+`</option>
								<option value="Ms">`+valueTitleValue4+`</option>
								<option value="Other">`+valueTitleValue5+`</option>
							</select>
						</div>
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueFirstnameLabel+`
						</label>
						<input type="text" name="first-name" value="" maxlength="40"
							class="form__input  form__input--required  
form__input--minmaxLength 
" placeholder="`+valueFirstnamePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueSurnameLabel+`
						</label>
						<input type="text" name="surname" value="" maxlength="20" class="form__input  form__input--required  
form__input--minmaxLength 
" placeholder="`+valueSurnamePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueTelephoneLabel+`
						</label>
						<input type="number" name="telephone-number" value="" class="form__input  form__input--required  
form__input--contact 
" placeholder="`+valueTelephonePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueEmailLabel+`
						</label>
						<input type="text" name="emailAddress" value="" class="form__input  
form__input--email 
" placeholder="`+valueEmailPlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueQueryLabel+`
						</label>
						<textarea name="comments" value="" maxlength="200" class="form__textarea  
form__input--minmaxLength 
" placeholder="`+valueQueryPlaceholder+`" rows="5"></textarea>
					</div>
					<div class="apply-now__note">
						<div class="apply-now__note-icon">
							<i data-component="icon" data-icon="icon-lock"
								data-gradient="" data-path="/file_source/assets/icons/"
								class="icon ">
							</i>
						</div>
						<div class="apply-now__note-text">
							`+valueLockValue+`
						</div>
					</div>
					<div class="apply-now__buttons">
						<a class="button button--medium apply-now__button js-apply-now__button"
							href="javascript:void(0);" target="" data-modal=""
							data-id="" data-text="">
							`+valueButtonValue+`
						</a>
					</div>
				</div>
				<div class="form__thankyou--container js-apply-now-success-message">
					<div
						class="title title--module-sub-title text-center enquiry__title">
						Thank you for your interest in our 'ProductName' </div>
					<p>One of our consultants will be in contact with you</p>
					<div class="access-quote__animation text-center">
						<img src="/file_source/assets/img/form-complete.gif"
							class="responsive-image responsive-image--animation">
					</div>
				</div>
			</form>`;

		}else if(type === 'nigeria-need-help') {
			content = `<form class="form" id="apply-now-submit_application_mail"
				data-frmcontainer="`+getFormName.value+`">
				<input type="hidden" name="recipient"
					value="`+getFormRecipient.value+`">
				<input type="hidden" name="email"
					value="`+getFormEmail.value+`">
				<input type="hidden" name="subject" value="`+getFormSubject.value+`">
				<input type="hidden" name="redirect" value="">
				<div class="form__loader--container">
					<img class="search__results-busy"
						src="/file_source/assets/img/spinner.gif" />
				</div>
				<div class="form__fields--container">
					<div class="form__group ">
						<p style="margin-bottom: 0px;">`+valueDescription+`</p>
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueTitleLabel+`
						</label>
						<div class="form__select">
							<select name="title" class="form__input  form__input--required 
	js-title ">
								<option value="Mr">`+valueTitleValue1+`</option>
								<option value="Mrs">`+valueTitleValue2+`</option>
								<option value="Miss">`+valueTitleValue3+`</option>
								<option value="Ms">`+valueTitleValue4+`</option>
								<option value="Other">`+valueTitleValue5+`</option>
							</select>
						</div>
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueFirstnameLabel+`
						</label>
						<input type="text" name="first-name" value="" maxlength="40"
							class="form__input  form__input--required  
	form__input--minmaxLength 
	" placeholder="`+valueFirstnamePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueSurnameLabel+`
						</label>
						<input type="text" name="surname" value="" maxlength="20" class="form__input  form__input--required  
	form__input--minmaxLength 
	" placeholder="`+valueSurnamePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueTelephoneLabel+`
						</label>
						<input type="number" name="telephone-number" value="" class="form__input  form__input--required  
	form__input--contact 
	" placeholder="`+valueTelephonePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueEmailLabel+`
						</label>
						<input type="text" name="emailAddress" value="" class="form__input  
	form__input--email 
	" placeholder="`+valueEmailPlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueQueryLabel+`
						</label>
						<textarea name="comments" value="" maxlength="200" class="form__textarea  
	form__input--minmaxLength 
	" placeholder="`+valueQueryPlaceholder+`" rows="5"></textarea>
					</div>
					<div class="apply-now__note">
						<div class="apply-now__note-icon">
							<i data-component="icon" data-icon="icon-lock"
								data-gradient="" data-path="/file_source/assets/icons/"
								class="icon ">
							</i>
						</div>
						<div class="apply-now__note-text">
							`+valueLockValue+`
						</div>
					</div>
					<div class="apply-now__buttons">
						<a class="button button--medium apply-now__button js-apply-now__button"
							href="javascript:void(0);" target="" data-modal=""
							data-id="" data-text="">
							`+valueButtonValue+`
						</a>
					</div>
				</div>
				<div class="form__thankyou--container js-apply-now-success-message">
					<div
						class="title title--module-sub-title text-center enquiry__title">
						Thank you for enquiring</div>
					<p>One of our consultants will be in contact with you to assist you
						with your enquiry</p>
					<div class="access-quote__animation text-center">
						<img src="/file_source/assets/img/form-complete.gif"
							class="responsive-image responsive-image--animation">
					</div>
				</div>
			</form>`;
		}else{
			
			let getFieldFeedbackLabel: any = this.element.querySelector('input[name=form-builder_field--feedback__label');
			let getFieldFeedbackCompliment: any = this.element.querySelector('input[name=form-builder_field--feedback__compliment');
			let getFieldFeedbackComplaint: any = this.element.querySelector('input[name=form-builder_field--feedback__complaint');

			let valueFeedbackLabel: any = 'Feedback Type';
			let valueFeedbackCompliment: any = 'Compliment';
			let valueFeedbackComplaint: any = 'Complaint';

			if(getFieldFeedbackLabel.value !==  '') {
				valueFeedbackLabel = getFieldFeedbackLabel.value;
			}
			if(getFieldFeedbackCompliment.value !==  '') {
				valueFeedbackCompliment = getFieldFeedbackCompliment.value;
			}
			if(getFieldFeedbackComplaint.value !==  '') {
				valueFeedbackComplaint = getFieldFeedbackComplaint.value;
			}

			content = `<form class="form" id="apply-now-submit_application_mail"
				data-frmcontainer="`+getFormName.value+`">
				<input type="hidden" name="recipient"
					value="`+getFormRecipient.value+`">
				<input type="hidden" name="email"
					value="`+getFormEmail.value+`">
				<input type="hidden" name="subject" value="`+getFormSubject.value+`">
				<input type="hidden" name="redirect" value="">
				<div class="form__loader--container">
					<img class="search__results-busy"
						src="/file_source/assets/img/spinner.gif" />
				</div>
				<div class="form__fields--container">
					<div class="form__group ">
						<p style="margin-bottom: 0px;">`+valueDescription+`</p>
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueFeedbackLabel+`
						</label>
						<div class="apply-now__radio">
							<label class="form__control form__control--radio">
							`	+valueFeedbackCompliment+`
								<input type="radio" name="feedback_type"
									value="compliment"
									class='js-identification_radio--group js-feedback-type__radio' />
								<div class="form__control-indicator"></div>
							</label>
							<label class="form__control form__control--radio">
								`+valueFeedbackComplaint+`
								<input type="radio" name="feedback_type"
									value="complaint"
									class='js-identification_radio--group js-feedback-type__radio' />
								<div class="form__control-indicator"></div>
							</label>
						</div>
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueTitleLabel+`
						</label>
						<div class="form__select">
							<select name="title" class="form__input  form__input--required 
	js-title ">
								<option value="Mr">`+valueTitleValue1+`</option>
								<option value="Mrs">`+valueTitleValue2+`</option>
								<option value="Miss">`+valueTitleValue3+`</option>
								<option value="Ms">`+valueTitleValue4+`</option>
								<option value="Other">`+valueTitleValue5+`</option>
							</select>
						</div>
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueFirstnameLabel+`
						</label>
						<input type="text" name="first-name" value="" maxlength="40"
							class="form__input  form__input--required  
	form__input--minmaxLength 
	" placeholder="`+valueFirstnamePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueSurnameLabel+`
						</label>
						<input type="text" name="surname" value="" maxlength="20" class="form__input  form__input--required  
	form__input--minmaxLength 
	" placeholder="`+valueSurnamePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueTelephoneLabel+`
						</label>
						<input type="number" name="telephone-number" value="" class="form__input  form__input--required  
	form__input--contact 
	" placeholder="`+valueTelephonePlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueEmailLabel+`
						</label>
						<input type="text" name="emailAddress" value="" class="form__input  
	form__input--email 
	" placeholder="`+valueEmailPlaceholder+`">
					</div>
					<div class="form__group ">
						<label class="form__label">
							`+valueQueryLabel+`
						</label>
						<textarea name="comments" value="" maxlength="200" class="form__textarea  
	form__input--minmaxLength 
	" placeholder="`+valueQueryPlaceholder+`" rows="5"></textarea>
					</div>
					<div class="apply-now__note">
						<div class="apply-now__note-icon">
							<i data-component="icon" data-icon="icon-lock"
								data-gradient="" data-path="/file_source/assets/icons/"
								class="icon ">
							</i>
						</div>
						<div class="apply-now__note-text">
							`+valueLockValue+`
						</div>
					</div>
					<div class="apply-now__buttons">
						<a class="button button--medium apply-now__button js-apply-now__button"
							href="javascript:void(0);" target="" data-modal=""
							data-id="" data-text="">
							`+valueButtonValue+`
						</a>
					</div>
				</div>
				<div class="form__thankyou--container js-apply-now-success-message">
					<div
						class="title title--module-sub-title text-center enquiry__title">
						Thank you for enquiring</div>
					<p>One of our consultants will be in contact with you to assist you
						with your enquiry</p>
					<div class="access-quote__animation text-center">
						<img src="/file_source/assets/img/form-complete.gif"
							class="responsive-image responsive-image--animation">
					</div>
				</div>
			</form>`;
		}

		let preview = this.element.querySelector('.form-builder__preview');
		preview.innerHTML = '';
		let docfragment = document.createDocumentFragment();
		docfragment.appendChild(document.createRange().createContextualFragment(content));
		preview.appendChild(docfragment);

		output.value = content;

	}



}


// WEBPACK FOOTER //
// ./components/form-builder/form-builder.component.ts